import { permissionsByEntity, useCheckPermissions } from '@cmg/auth';
import { DataGridContextProvider } from '@cmg/data-grid';
import { PageLayout, Stack, SxProps, Theme } from '@cmg/design-system';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { useOfferingProfile_LiteQuery } from '../../offering-dl/offering-profile/graphql/__generated__/OfferingProfile';
import ScreenHeader from '../../shared/layout/ScreenHeader';
import { useOfferingProfile_GetParticipationRecordsQuery } from './graphql/__generated__/GetParticipationRecords';
import ParticipationSubHeader from './ParticipationSubHeader';
import { ViewParticipationSet } from './ViewParticipationSet';

const cardStyle: SxProps<Theme> = {
  zIndex: 1,
  boxShadow: 4,
  paddingTop: 0,
  marginBottom: 2,
};

type locationState = {
  isModalOpen?: boolean;
};
const ManageParticipationSetRouteComponent: React.FC = () => {
  const location = useLocation<locationState>();
  const isModalOpen = location.state?.isModalOpen;
  const { offeringId } = useParams<{ offeringId: string }>();
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = React.useState(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = React.useState<boolean>(!!isModalOpen);
  const { data: offeringProfile, error } = useOfferingProfile_LiteQuery({
    variables: {
      offeringId,
      hasMySectorsPermission: useCheckPermissions([permissionsByEntity.CustomSectors.READ]),
    },
  });
  const {
    data: participation,
    refetch,
    loading,
  } = useOfferingProfile_GetParticipationRecordsQuery({
    variables: {
      skip: 0,
      take: 1000,
      where: {
        participationSet: {
          offeringId: {
            eq: offeringId,
          },
        },
      },
      setFilter: {
        offeringId: {
          eq: offeringId,
        },
      },
    },
    fetchPolicy: 'no-cache',
  });

  const onOpenImportDialog = () => {
    setIsUploadModalOpen(true);
  };

  const onCloseImportDialog = () => {
    setIsUploadModalOpen(false);
  };
  return (
    <Stack flex={1} style={{ height: '100%' }}>
      <ScreenHeader />
      {offeringProfile && !error && (
        <PageLayout
          flex={1}
          header={
            <Stack sx={cardStyle}>
              <ParticipationSubHeader
                offeringProfile={offeringProfile}
                onDeleteButtonClicked={() => setIsDeleteDialogOpen(true)}
                showDropdownActionButton={
                  (participation?.participationRecords?.items ?? []).length > 0
                }
                onOpenImportDialog={onOpenImportDialog}
              />
            </Stack>
          }
        >
          <ViewParticipationSet
            issuerName={offeringProfile.offeringById?.issuer?.name ?? ''}
            participation={participation}
            refetchParticipationQuery={refetch}
            isDeleteDialogOpen={isDeleteDialogOpen}
            onCloseDeleteDialog={() => setIsDeleteDialogOpen(false)}
            loading={loading}
            isImportDialogOpen={isUploadModalOpen}
            onCloseImportDialog={onCloseImportDialog}
            onOpenImportDialog={onOpenImportDialog}
          />
        </PageLayout>
      )}
    </Stack>
  );
};

const ManageParticipationSetRoute: React.FC = props => {
  return (
    <DataGridContextProvider>
      <ManageParticipationSetRouteComponent />
    </DataGridContextProvider>
  );
};

export default ManageParticipationSetRoute;
